module.exports = __webpack_public_path__ + "static/media/smileRating5Active.ae644c65.svg";